export const config = {
    baseUrl: "http://192.168.123.71:3001",
}